import { render, staticRenderFns } from "./CaseProductsLiability.vue?vue&type=template&id=63bbd1aa"
import script from "./CaseProductsLiability.vue?vue&type=script&lang=js"
export * from "./CaseProductsLiability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports